import { AvailabilityZoneSettings, ChannelInfo } from "../../../domain/channel";
import { ToastrService } from "ngx-toastr";

export class ChannelJsonEditorViewModel {
  public lastValidatedJson: string;
  public channelJson: string;
  constructor(
    public availabilityZoneSettings: AvailabilityZoneSettings,
    public availabilityZoneName: string,
    private _channelInfo: ChannelInfo,
    private generateChannelJson: () => Promise<string>,
    private closePopup: () => void,
    private detectChanged: () => void,
    private _toastr: ToastrService,
  ) {
    this.channelJson = availabilityZoneSettings.overrideChannelJson;
    this.lastValidatedJson = availabilityZoneSettings.overrideChannelJson;
  }
  public get canRevertChanges(): boolean {
    return this.channelJson !== this.lastValidatedJson;
  }
  public async generateChannelJsonClicked() {
    this.channelJson = await this.generateChannelJson();
    this.lastValidatedJson = this.channelJson;
  }
  public copyButtonClickedEventHandler() {
    this._toastr.success("JSON has been copied!");
  }
  public applyButtonClickedEventHandler() {
    if (this._validateJson(this.channelJson)) {
      this.availabilityZoneSettings.overrideChannelJson = this.channelJson;
      this.closePopup();
    } else {
      this._toastr.error(`JSON Validation Failed!`);
    }
  }

  public resetButtonClickedEventHandler() {
    this.channelJson = this.availabilityZoneSettings.overrideChannelJson;
    this.lastValidatedJson = this.channelJson;
    this.detectChanged();
  }
  revertChangesClickedEventHandler() {
    if (this._validateJson(this.channelJson)) {
      this.lastValidatedJson = this.channelJson;
    } else {
      this._toastr.warning(`Reverting back changes...`);
      this.channelJson = null;
      this.detectChanged();
      this.channelJson = this.lastValidatedJson;
      this.detectChanged();
    }
  }

  channelJsonAreaChanged(newVal: string) {
    this.channelJson = newVal;
    if (this._validateJson(newVal)) {
      this.lastValidatedJson = newVal;
    }
  }

  private _validateJson(newVal: string): boolean {
    try {
      const channelJson = JSON.parse(newVal);
      if (channelJson["ChannelUID"] !== this._channelInfo.uid) {
        this._toastr.error(`Channel UID mismatch!`);
        return false;
      }

      return true;
    } catch (e) {
      return false;
    }
  }
}
